/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ConversationGroupModel } from "./ConversationGroupModel";
import type { ConversationModel } from "./ConversationModel";
import type { EventModel } from "./EventModel";
import type { PaginationModel } from "./PaginationModel";

export interface ConversationGroupResponse {
  conversation_group: ConversationGroupModel;
  conversations: ConversationModel[];
  messages: EventModel[];
  pagination: PaginationModel;
}
